import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicNotSelectedGuard
} from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'
import EmptyResultGuard from './EmptyResultGuard'
import WidgetLoadingGuard from './WidgetLoadingGuard'
import RunSearchEffect from '../RunSearchEffect/index'

const PopularLinksWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <RunSearchEffect widgetId={widgetId}>
      <WidgetLoadingGuard widgetId={widgetId}>
        <TopicInaccessibleGuard widgetId={widgetId}>
          <TopicIndexNotReadyGuard widgetId={widgetId}>
            <EmptyResultGuard widgetId={widgetId}>{children}</EmptyResultGuard>
          </TopicIndexNotReadyGuard>
        </TopicInaccessibleGuard>
      </WidgetLoadingGuard>
    </RunSearchEffect>
  </TopicNotSelectedGuard>
)

export default PopularLinksWidgetDataGuards
